import { useMutation } from "@tanstack/react-query";
import { gqlReqNext } from "~utils/api/gql-req/next";
import type { CreateManagedAccountInput } from "~mangomap-ui/templates/partner-templates/types";
import {
	CreateManagedAccountMutation,
	CreateManagedAccountMutationVariables,
} from "~/types/__generated/gql/graphql";

const mutation = /* GraphQL */ `
	mutation CreateManagedAccount($input: CreateManagedAccountInput!) {
		createManagedAccount(input: $input) {
			id
		}
	}
`;

const createManagedAccountMutationFn = async (
	input: CreateManagedAccountInput,
) => {
	return gqlReqNext<
		CreateManagedAccountMutation,
		CreateManagedAccountMutationVariables
	>({
		query: mutation,
		variables: {
			input,
		},
	});
};

export const useCreateManagedAccount = () => {
	return useMutation({
		mutationFn: createManagedAccountMutationFn,
	});
};
